module.exports = __webpack_public_path__ + "img/full7-min.6b4c76d7.png";